import './projectOverview.scss';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useHistory } from 'react-router';
import { Loader } from '../../../../__legacy__/components/Loader';
import { EnableFor } from '../../../../__legacy__/containers/EnableForRole';
import { useAnnotationPermissions } from '../../../../__legacy__/modules/annotation/annotation.permissions';
import { Home } from '../../../../__legacy__/routes/config/Home';
import { S_Card } from '../../../../design/card/card/S_Cards';

interface IAnnotatingOverviewWidgetProps {
  isLoading: boolean;
  waitingForAnnotationCount: number;
  draftsCount: number;
  toReviewCount: number;
  acceptedCount: number;
  totalImageCount: number;
  projectId: string;
  workspaceId: string;
}

export const AnnotatingOverviewWidget = observer((props: IAnnotatingOverviewWidgetProps): ReactElement => {
  const { t } = useTranslator();
  const history = useHistory();
  const permissions = useAnnotationPermissions();

  const annotated = props.toReviewCount + props.acceptedCount;
  const percentage = props.totalImageCount === 0 ? 0 : ((annotated / props.totalImageCount) * 100).toFixed(2);

  return (
    <S_Card className='overview-card card-with-list'>
      <Loader isLoading={props.isLoading}>
        <div className='info'>
          <h5>
            {t('annotation_progress')} {annotated}/{props.totalImageCount} ({percentage}%)
          </h5>
          <div className='list-row'>
            <div className='left'>{t('waiting_for_annotation')}</div>
            <div className='right'>{props.waitingForAnnotationCount}</div>
          </div>
          <div className='list-row'>
            <div className='left'>{t('waiting_for_submission')}</div>
            <div className='right'>{props.draftsCount}</div>
          </div>
        </div>
        <div className='bottom'>
          <EnableFor
            hasPermission={permissions.canSeeAnnotateButton(props.projectId)}
            hideWhenNoAccess
          >
            <EnableFor hasPermission={permissions.canAnnotate(props.projectId)}>
              <Button
                onClick={() => {
                  history.push(Home.Annotations.Create.withParams({ projectId: props.projectId, workspaceId: props.workspaceId }));
                }}
              >
                {t('start_annotation')}
              </Button>
            </EnableFor>
          </EnableFor>
        </div>
      </Loader>
    </S_Card>
  );
});
